<script lang="ts" context="module">
  type SwimlaneType = "new" | "recommended" | "order_again" | "nearby_deals" | "happy_hour";

  type BaseSwimlane = {
    type: SwimlaneType;
    sort: SortType;
  }

	export type RestaurantSwimlane = BaseSwimlane & {
    type: "new" | "recommended" | "order_again" | "nearby_deals" | "happy_hour";
		swimlane: {
			restaurant_ids: number[];
		};
	};

  export type Swimlane = RestaurantSwimlane;
</script>

<script lang="ts">
	import type { LandingItemContext, RestaurantDynamic, RestaurantsDynamic, RestaurantSemiStatic, RestaurantsSemiStatic, SortType } from "$lib/def/landing";
	import type { Cache } from "$lib/serv/core/cache";
	
	import { Vertical } from "$lib/def/verticals";
	import { fetch$ } from "$lib/serv/core/cache";
	import { getDB, sort, SPKEYS, type DealsLoader } from "$lib/serv/food-landing";
	import { EMPTY, map, shareReplay, Subject, Subscription, switchMap } from "rxjs";
	import { getContext, onDestroy } from "svelte";
	
	import CarouselV3 from "$lib/ui/layout/CarouselV3.svelte";
	import Tile from "$lib/ui/home/food/Tile.svelte";

	export let title: string | undefined;
	export let endpoint: string | undefined;
	export let semistatic: Cache<RestaurantsSemiStatic> | null;
	export let dynamic: Cache<RestaurantsDynamic> | null;
	export let deals: DealsLoader | null;
	export let searchParams: Record<string, string>;

	const { base: host, cacheAge } = getContext('endpoints') as LandingItemContext;

  const _input$ = new Subject<{
	  title: string | undefined;
	  endpoint: string | undefined;
	  semistatic: Cache<RestaurantsSemiStatic> | null;
	  dynamic: Cache<RestaurantsDynamic> | null;
	  deals: DealsLoader | null;
	  searchParams: Record<string, string>;
    host: string | undefined;
  }>();

  const input$ = _input$.pipe(shareReplay(1)); // workaround for Svelte 5 late template subscription

  $: _input$.next({
    title,
	  endpoint,
	  semistatic,
	  dynamic,
	  deals,
	  searchParams,
    host,
  });

  const inputSub = input$.subscribe((input) => {
    const {semistatic, dynamic, deals} = input;
		// if (semistatic || dynamic || deals) resize?.();
  });

	type Data = {
		swimlane: {
			restaurant_ids:number[],
		},
		sort: SortType,
	};
	
	let loadingSemiStatic = true;
	// let semistatic: RestaurantSemiStatic[];
	let subSemiStatic: Subscription;
	// let dynamic: RestaurantDynamic[];
	let subDynamic: Subscription;

	// let cache: Observable<Cache<Data>>;
	// let subCache: Subscription | undefined = undefined;;
	// $: {
	// 	cache = endpoint
	// 	? fetch$<Data>(new URL(base + endpoint), SPKEYS, { db: getDB(), msMaxCacheAge: cacheAge.medium }).pipe(
	// 		map((cache) => {
	// 			if (cache.payload?.swimlane.restaurant_ids) {
	// 				cache.payload.swimlane = {
	// 					restaurant_ids: sort(cache.payload.swimlane.restaurant_ids, cache.payload.sort, dynamic?.payload),
	// 				};
	// 			}

	// 			return cache;
	// 		}),
	// 		shareReplay(1),
	// 	)
	// 	: EMPTY;


	const cache$ = _input$.pipe(
    switchMap((inp) => {
      let {endpoint, host} = inp;
      if (!host || !endpoint) return EMPTY;
      const url = host + endpoint;

		  return fetch$<Swimlane>(new URL(url), SPKEYS, { db: getDB(), msMaxCacheAge: cacheAge.medium }).pipe(
		  	map((cache) => {
          if (cache.payload === undefined) {
            return cache;
          }

		  	  cache.payload.swimlane.restaurant_ids = sort(cache.payload.swimlane.restaurant_ids ?? [], cache.payload.sort, dynamic?.payload);
          return cache;
		  	})
		  )
    }),
  );

  const subCache = cache$.subscribe(); // workaround for Svelte 5 late template subscription
	onDestroy(() => {
		subCache?.unsubscribe();
    inputSub.unsubscribe();
	});

  const keyRestLane = (s: RestaurantSwimlane) => s.swimlane.restaurant_ids;
  const rCache = (c: any) => c as Cache<RestaurantSwimlane>;
</script>

{#snippet t()}
	<h2 class="title headline-m bold">{title}</h2>
{/snippet}

<!--{#if $cache$?.payload?.swimlane && 'restaurant_ids' in $cache$?.payload.swimlane}-->
  <!-- {@const t = title ?? $cache$.payload.type} -->
  <CarouselV3 cache={$cache$} type="swimlane" key={({swimlane}) => (swimlane as {restaurant_ids:number[]}).restaurant_ids} title={t}>
    {#snippet children({ item: id })}
      {@const ss = semistatic?.payload?.semi_static?.find(r => r.id === id)}
      {@const d = dynamic?.payload?.dynamic?.find(r => r.id === id)}
      {@const ds = deals?.restaurants?.get(id)}
      <Tile {searchParams} tile={{type: Vertical.Restaurant, payload: { id }}} semistatic={ss} dynamic={d} deals={ds}/>
    {/snippet}
  </CarouselV3>
<!--{/if}-->

<style lang="scss">
  @use "color";

  .item {
    text-align: left;
  }
</style>
